import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const H3Icon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`H3`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M11.287 6.354c.769-.452 1.614-.477 2.292-.158.672.317 1.17.98 1.171 1.804 0 .49-.174.96-.484 1.332.31.373.484.844.484 1.334 0 .889-.502 1.66-1.276 2.009-.74.332-1.624.242-2.431-.295l-.16-.113-.059-.05a.75.75 0 0 1 .896-1.194l.063.043.177.12c.4.236.713.205.898.122a.68.68 0 0 0 .392-.642.585.585 0 0 0-.584-.583.753.753 0 0 1-.292-.059.753.753 0 0 1-.454-.767c.004-.035.012-.068.02-.102a.753.753 0 0 1 .726-.572h.001A.584.584 0 0 0 13.25 8c0-.176-.1-.348-.312-.447-.205-.097-.527-.12-.891.093a.75.75 0 0 1-.76-1.292ZM8 3.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8.75H3.417V12a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 1.5 0v3.25H7.25V4A.75.75 0 0 1 8 3.25Z"
    />
  </Icon>
);
